export const validateProperties = (argument, ...properties) => {
    return properties.reduce((p, c, i) => {
        console.log(`currently: `, c, p[c])
        if (!!p[c]) {
            if (i === (properties.length - 1)) {
                return p[c];
            } else {
                return p[c];
            }
        } else if(Array.isArray(p)) {
            console.log(`It's array: `, c, properties.slice(i))
            return p.reduce((_p, _arrayObj) => {
                return _p && validateProperties(_arrayObj, properties.slice(i))
            }, true)
        }else {
            return ''
        }
    }, argument);
}


export const buildStateObjectReducer = (stateVariable, stateSetter) => {
    const editState = (...properties) => {
        return (value) => {
            properties.reduce((p, c, i) => {
                if (!!p[c]) {
                    if (i === (properties.length - 1)) {
                        if (c === 'mobile') {
                            value = value.replace('+1', '').replace(/([A-z])/g, '');
                        }
                        p[c] = value;
                        return p[c];
                    } else {
                        return p[c];
                    }
                } else {
                    if (i === (properties.length - 1)) {
                        if (c === 'mobile') {
                            value = value.replace('+1', '').replace(/([A-z])/g, '');
                        }
                        p[c] = value;
                        return p[c];
                    } else {
                        p[c] = {};
                        return p[c];
                    }
                }
            }, stateVariable);
            stateSetter(Object.assign({}, stateVariable));
        }
    }
    const getFromState =  (...properties) => {
        return properties.reduce((p, c, i) => {
            if (!!p[c]) {
                if (i === (properties.length - 1)) {
                    return p[c];
                } else {
                    return p[c];
                }
            } else {
                return ''
            }
        }, stateVariable);
    }

    return [getFromState, editState]
}
